// ** React Imports
/* eslint-disable */
import { Suspense, lazy } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

// ** Redux Imports
import { store, persistor } from "./redux/store";
import { Provider, useSelector } from "react-redux"

// ** ThemeColors Context

import { ThemeContext } from "./utility/context/ThemeColors"

// ** ThemeConfig
import themeConfig from "./configs/themeConfig"

// ** Toast
import { Toaster } from "react-hot-toast"

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"

// ** Ripple Button
import "./@core/components/ripple-button"

// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss"

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"
import { PersistGate } from "redux-persist/integration/react";


import toast from "react-hot-toast";

// ** Apollo Client Imports
import { setContext } from "@apollo/link-context";
import { createUploadLink } from "apollo-upload-client";
import { onError } from "@apollo/client/link/error";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  useMutation,
} from "@apollo/client";

// ** Service Worker
import * as serviceWorker from "./serviceWorker"

// ** Lazy load app


const LazyApp = lazy(() => import("./App"))
//let errorProcessed = false;
const container = document.getElementById("root")
const root = createRoot(container)

// const uploadLink = createUploadLink({
//   uri: process.env.REACT_APP_BASEURL,
//   credentials: "same-origin",
// });

//const refreshToken = store.getState()?.user?.user?.accessToken;
//console.log(refreshToken, "token accessed directly");

// const unsubscribe = store.subscribe(() => {
//   // Retrieve the updated token whenever the state changes
//   const updatedRefreshToken = store.getState()?.user?.user?.refreshToken;

//   // Perform some action with the updated token
//   if (refreshToken !== updatedRefreshToken) {
//     refreshToken = updatedRefreshToken;
//     console.log(refreshToken, "updated token")
//   }
// });

// unsubscribe();

// const removeSlashesAndQuotes = (str) => {
//   // Remove backslashes and double quotes
//   return str.replace(/["\\]/g, "")
// };

// Create the auth link to include the token in the headers
// const authLink = setContext((_, { headers }) => {
//   const token = localStorage.getItem("accessToken") || null;

//   return {
//     headers: {
//       ...headers,
//       authorization: token ? removeSlashesAndQuotes(token) : null,
//     },
//   };
// });

// const errorLink = onError(({ graphQLErrors, networkError }) => {
//   if (!errorProcessed) {
//     errorProcessed = true;

//     if (graphQLErrors) {
//       graphQLErrors.forEach(({ message, locations, path }) => {
//         toast.error(`${message}`, {
//           theme: "dark",
//         });

//         console.error(
//           `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
//         )
//       })
//     }

//     if (networkError) {
//       toast.error(`[Network error]: ${networkError.message}`, {
//         theme: "dark",
//       });
//       console.error(`[Network error]: ${networkError}`);
//     }
//     // Reset the flag after a short delay to allow handling new errors
//     setTimeout(() => {
//       errorProcessed = false;
//     }, 500); // Adjust the timeout as needed
//   }
// });
// Combine the upload link and auth link using ApolloLink
//const link = ApolloLink.from([authLink, errorLink, uploadLink]);

// Initialize the Apollo Client
// const client = new ApolloClient({
//   link: link,
//   cache: new InMemoryCache(),
// });

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Spinner />}>
          <ThemeContext>
              <LazyApp />
            <Toaster
              position={themeConfig?.layout?.toastPosition}
              toastOptions={{ className: "react-hot-toast" }}
            />
          </ThemeContext>
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("✅ Service Worker registered:", registration);
    })
    .catch((error) => {
      console.error("❌ Service Worker registration failed:", error);
    });
}

